"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalReportingGroups = void 0;
var GalReportingGroups;
(function (GalReportingGroups) {
    GalReportingGroups["product"] = "product";
    GalReportingGroups["unrestricted"] = "unrestricted";
    GalReportingGroups["inactive"] = "inactive";
    GalReportingGroups["game"] = "game";
    GalReportingGroups["system"] = "system";
    GalReportingGroups["pokergo"] = "pokergo";
    GalReportingGroups["townstar"] = "townstar";
})(GalReportingGroups = exports.GalReportingGroups || (exports.GalReportingGroups = {}));
